import TemperatureRange from '../oc-temperature-range';

const CMSTemperatureRange = () => <TemperatureRange />;

export default CMSTemperatureRange;
